import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id FEA26660-7D6A-4C2A-9F13-7AE125FBA543
 * name close
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close.svg
 * tags
 * - Math 
 * - Form 
 */
export const CloseIcon = createSvgIcon(<><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></>, 'CloseIcon');
export default CloseIcon